module.exports = __webpack_public_path__ + "img/twitter.f1cd7a60.svg";